import React from "react";
import { motion } from "framer-motion";
import { TID } from "@/constants/testIds";

// Mapped 1:1 to the real chapters of PARTE I — "La Rotta"
const pillars = [
  {
    n: "01",
    title: "La mia storia",
    text:
      "L'origine del metodo: dal sogno di libertà bambino ai nove anni sull'Amerigo Vespucci. Disciplina, silenzio operativo e responsabilità come fondamenta.",
  },
  {
    n: "02",
    title: "Il metodo dietro il cambiamento",
    text:
      "Cambiare ambiente, ruolo o abitudini non basta: senza una direzione chiara è solo movimento. Il metodo è ciò che trasforma il cambiamento in evoluzione.",
  },
  {
    n: "03",
    title: "La vendita come scuola di vita",
    text:
      "Nella vendita perdi ogni protezione. La vendita non mette alla prova il prodotto, mette alla prova la persona. Comunicazione reale, resilienza, leadership sul campo.",
  },
  {
    n: "04",
    title: "Reti, non dipendenze dai singoli",
    text:
      "La crescita senza struttura non è crescita: è esposizione. Smettere di affidarsi al talento del singolo per costruire sistemi che reggono nel tempo.",
  },
  {
    n: "05",
    title: "Quando il digitale diventa rischio",
    text:
      "Il digitale amplifica tutto: ciò che funziona e ciò che è fragile. Crescere velocemente senza protezione significa correre verso un punto cieco.",
  },
  {
    n: "06",
    title: "La cybersicurezza non è tecnologia",
    text:
      "Firewall e antivirus non bastano. La vulnerabilità nasce nelle abitudini, nelle scelte quotidiane. La sicurezza è una questione di cultura e leadership.",
  },
  {
    n: "07",
    title: "Metodo, digitale e sicurezza: l'unione",
    text:
      "Il vero vantaggio competitivo, oggi, non è crescere. È restare solidi mentre cresci. Una visione integrata in cui ogni elemento parla la stessa lingua.",
  },
];

export default function Pillars() {
  return (
    <section
      id="method"
      data-testid={TID.pillarsSection}
      className="relative py-24 md:py-32 border-t border-[#E5E1DA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-24 items-end">
          <div className="md:col-span-5">
            <p className="overline">Parte I · La Rotta</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">
              Sette pilastri.
              <br />
              <em className="text-[#0E7C8F]">Una rotta sola.</em>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <p className="text-lg font-light leading-relaxed text-[#3A4F6B]">
              Metodo di Mare non è una raccolta di consigli. È un sistema
              forgiato sul campo: dalla disciplina dell'Amerigo Vespucci alla
              vendita diretta, dalla costruzione di reti commerciali alla
              cybersicurezza. Sette capitoli che disegnano la rotta.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-[#E5E1DA]">
          {pillars.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              className={`p-8 md:p-10 border-b border-[#E5E1DA] ${
                i % 3 !== 2 ? "lg:border-r" : ""
              } ${
                i % 2 !== 1 ? "md:border-r lg:border-r" : ""
              } group hover:bg-[#FFFFFF] transition-colors`}
              data-testid={`pillar-${p.n}`}
            >
              <p className="font-serif-display text-5xl text-[#E89B6C]">{p.n}</p>
              <h3 className="font-serif-display text-2xl md:text-3xl mt-6 text-[#0B192C] leading-tight">
                {p.title}
              </h3>
              <p className="mt-4 font-light leading-relaxed text-[#3A4F6B]">
                {p.text}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Part II teaser */}
        <div className="mt-20 border border-[#0B192C] p-8 md:p-12 bg-[#FFFFFF]">
          <div className="grid md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-5">
              <p className="overline">Parte II · Il Metodo</p>
              <h3 className="font-serif-display text-3xl md:text-4xl mt-3 leading-tight">
                Struttura, leadership
                <br />
                <em className="text-[#0E7C8F]">e continuità.</em>
              </h3>
            </div>
            <div className="md:col-span-7">
              <p className="text-lg font-light text-[#3A4F6B]">
                Otto capitoli operativi: linguaggio e valori, obiettivo
                strategico, prodotto di ruolo, metodo operativo, leadership e
                duplicazione, disciplina, e come diventare un professionista
                certificato nel mondo digitale.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {[
                  "Valori",
                  "Visione",
                  "Prodotto di ruolo",
                  "Pianificazione",
                  "Delega efficace",
                  "Duplicazione",
                  "Disciplina",
                ].map((t) => (
                  <span
                    key={t}
                    className="px-3 py-1 border border-[#E5E1DA] text-xs uppercase tracking-[0.15em] text-[#3A4F6B]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
